import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "container" }

import { ref, computed } from 'vue';
import { getDefaultRewards } from '@/utils/commonFunction';
import { DAY_COUNT, RechargeGiftData } from '@/view/rechargeGift/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import CashbackNotice from '../components/common/cashbackNotice.vue';
import CashBackCard from '../components/common/cashBackCard.vue';
import CashbackWeekDetails from '../components/common/cashbackWeekDetails.vue';
import CashbackHistoryPopup from '../components/common/cashbackHistoryPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'rechargeGift',
  props: {
    dataSet: {}
  },
  emits: ['getNextPageRewardData', 'getHistoryList', 'resetHistoryData', 'getClaim'],
  setup(__props: any, { emit: __emit }) {

const histryPopupRef = ref();

const dayCount = ref(DAY_COUNT)

const props = __props

const formattedMessages = computed(() =>
    props.dataSet.activityDescription.map(msg => msg.replace(/\\n/g, '\n'))
);

const emits = __emit

const getNextPageRewardData = () => {
    emits('getNextPageRewardData')
}
const getHistoryList = () => {
    emits('getHistoryList')
}

const resetHistoryData = () => {
    emits('resetHistoryData')
}
const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}

const getClaim = () => {
    emits('getClaim')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.recharge_gift'),
      "show-history": true,
      onOpenHistoryPopup: openHistoryPopup
    }, null, 8, ["text"]),
    _createElementVNode("img", {
      class: "bg-top-img",
      src: _ctx.dataSet.bannerIcon
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CashbackNotice, { content: formattedMessages.value }, null, 8, ["content"]),
      _createElementVNode("div", null, [
        _createVNode(CashBackCard, {
          title: _ctx.$t('common.bets'),
          "create-date": _ctx.dataSet.todayRechargeGiftDetails?.createTime,
          day: _ctx.dataSet.todayRechargeGiftDetails?.day,
          "available-value": _ctx.dataSet.todayRechargeGiftDetails?.availableAmount,
          showClickButton: _ctx.dataSet.todayRechargeGiftDetails?.availableAmount > 0,
          "given-value": _ctx.dataSet.todayRechargeGiftDetails?.givenAmount,
          onGetClaim: getClaim,
          dayList: _ctx.dataSet.futureRewards.length <= 0 ? _unref(getDefaultRewards)(dayCount.value) : _ctx.dataSet.futureRewards
        }, null, 8, ["title", "create-date", "day", "available-value", "showClickButton", "given-value", "dayList"])
      ]),
      _createVNode(CashbackWeekDetails, {
        "bet-list": _ctx.dataSet.weeklyRechargeGiftList,
        title: _ctx.$t('myDataView.totalRecharge'),
        "cashback-total": _ctx.dataSet.cashbackTotal,
        type: "RECHARGE",
        "istoday-claimed": _ctx.dataSet.todayRechargeGiftDetails?.availableAmount > 0
      }, null, 8, ["bet-list", "title", "cashback-total", "istoday-claimed"]),
      _createVNode(CashbackHistoryPopup, {
        ref_key: "histryPopupRef",
        ref: histryPopupRef,
        onGetHistoryList: getHistoryList,
        list: _ctx.dataSet.historyList,
        title: _ctx.$t('myDataView.totalRecharge'),
        onUpdateHistoryList: getNextPageRewardData,
        showIcon: _ctx.dataSet.total > _ctx.dataSet.pageSize * _ctx.dataSet.pageNum,
        onResetHistoryData: resetHistoryData
      }, null, 8, ["list", "title", "showIcon"])
    ])
  ], 64))
}
}

})